export default "__VITE_ASSET__CeDvODNp__"